/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Timeline_Track_Range_SummaryInputs */

const en_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Range: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
};

const fr_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Plage : ${i?.start}s - ${i?.end}s, Total : ${i?.total})`)
};

const de_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Bereich: ${i?.start}s - ${i?.end}s, Gesamt: ${i?.total})`)
};

const it_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Intervallo: ${i?.start}s - ${i?.end}s, Totale: ${i?.total})`)
};

const ru_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Диапазон: ${i?.start}s - ${i?.end}s, Всего: ${i?.total})`)
};

const es_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Rango: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
};

const zh_cn2_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（范围：${i?.start}s - ${i?.end}s，总计：${i?.total}）`)
};

const ja_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(範囲: ${i?.start}s - ${i?.end}s、合計: ${i?.total})`)
};

const hi_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(श्रेणी: ${i?.start}s - ${i?.end}s, कुल: ${i?.total})`)
};

const pt_pt2_timeline_track_range_summary = /** @type {(inputs: Timeline_Track_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Intervalo: ${i?.start}s - ${i?.end}s, Total: ${i?.total})`)
};

/**
* | output |
* | --- |
* | "(Range: {start}s - {end}s, Total: {total})" |
*
* @param {Timeline_Track_Range_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_range_summary = /** @type {((inputs: Timeline_Track_Range_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_Range_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_track_range_summary(inputs)
	if (locale === "de") return de_timeline_track_range_summary(inputs)
	if (locale === "it") return it_timeline_track_range_summary(inputs)
	if (locale === "ru") return ru_timeline_track_range_summary(inputs)
	if (locale === "es") return es_timeline_track_range_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_track_range_summary(inputs)
	if (locale === "ja") return ja_timeline_track_range_summary(inputs)
	if (locale === "hi") return hi_timeline_track_range_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_track_range_summary(inputs)
	return en_timeline_track_range_summary(inputs)
});